/**
 * Creates a solved puzzle board of given size
 *
 * Generates an array representing the solved state where each tile
 * is in its correct position (board[i] === i).
 *
 * @param {number} size - Board dimension (e.g., 3 for 3x3 = 9 tiles)
 * @returns {number[]} Array of sequential numbers [0, 1, 2, ..., size*size-1]
 *
 * @example
 * makeSolved(3)  // [0, 1, 2, 3, 4, 5, 6, 7, 8] (3x3 board)
 * makeSolved(4)  // [0, 1, 2, ..., 15] (4x4 board)
 */
export function makeSolved (size) {
  const total = size * size
  return Array.from({ length: total }, (_, i) => i)
}
